export default "__VITE_ASSET__6b809be1__"